module.exports = __webpack_public_path__ + "img/assistencia-medica.8b4560a6.png";